import React, { useEffect, useRef } from 'react'
import { useColorMode } from "theme-ui"

const Giscus = () => {
    const ref = useRef<HTMLDivElement>(null)
    const [colorMode] = useColorMode()
    const theme = colorMode === 'dark' ? 'dark' : 'light'

    useEffect(() => {
        if (!ref.current || ref.current.hasChildNodes()) return

        const script = document.createElement('script')
        script.src = 'https://giscus.app/client.js'
        script.setAttribute('data-repo', "jsean662/JBLOG-COMMENTS")
        script.setAttribute('data-repo-id', process.env.GATSBY_GISCUS_REPO_ID || "")
        script.setAttribute('data-category', "General")
        script.setAttribute('data-category-id', process.env.GATSBY_GISCUS_CATEGORY_ID || "")
        script.setAttribute('data-mapping', "pathname")
        script.setAttribute('data-term', "Welcome to @giscus/react component!")
        script.setAttribute('data-reactions-enabled', "1")
        script.setAttribute('data-emit-metadata', "0")
        script.setAttribute('data-input-position', "top")
        script.setAttribute('data-theme', theme)
        script.setAttribute('data-lang', "en")
        script.setAttribute('data-loading', "lazy")
        script.crossOrigin = 'anonymous'
        script.async = true

        ref.current.appendChild(script)
    }, [])

    // Handle theme updates
    useEffect(() => {
        const iframe = document.querySelector<HTMLIFrameElement>('iframe.giscus-frame');
        if (!iframe) return;
        iframe.contentWindow?.postMessage({ giscus: { setConfig: { theme } } }, 'https://giscus.app');
    }, [theme])

    return <div ref={ref} />
}

export default Giscus
